import { i18n } from '@fs/zion-locale'

export default {
  active: () => i18n.t('searchResultsPage.active', 'Active'),
  actions: () => i18n.t('searchResultsColumns.actions', 'Actions'),
  advancedSearch: () => i18n.t('searchForm.advancedSearch', 'Advanced Search'),
  allMetadataCorrected: () =>
    i18n.t('searchResultsPage.allMetadataCorrectedCompleteMessage', 'Correct Metadata task complete'),
  allPlaces: () => i18n.t('searchResultsPage.allPlaces', 'All Places'),
  allRecordTypes: () => i18n.t('searchResultsPage.tab.allRecordTypes', 'All Record Types'),
  clanJiapuSurnameCollection: (surname) =>
    i18n.t('searchResultsPage.header.clanJiapuSurnameCollection', '{surname} Clan Jiapu Collection', { surname }),
  clanJokboSurnameCollection: (surname) =>
    i18n.t('searchResultsPage.header.clanJokboSurnameCollection', '{surname} Clan Jokbo Collection', { surname }),
  clanKeizuSurnameCollection: (surname) =>
    i18n.t('searchResultsPage.header.clanKeizuSurnameCollection', '{surname} Clan Keizu Collection', { surname }),
  correctMetadata: () => i18n.t('searchResultsPage.correctMetadata', 'Correct Metadata'),
  divideImageGroup: () => i18n.t('searchResultsPage.divideImageGroup', 'Divide Image Group'),
  divideCompleteMessage: () => i18n.t('searchResultsPage.divideCompleteMessage', 'Divide Image Group task complete.'),
  exploreImages: () => i18n.t('searchResultsPage.exploreImages', 'Explore Images Results'),
  images: () => i18n.t('searchResultsPage.columns.imagesLabel', 'images'),
  imagesIndexed: (count, total) =>
    i18n.t('searchResultsPage.imagesIndexed', '{count} of {total} images', {
      count,
      total,
    }),
  imagesIndexedPercent: (percent) =>
    i18n.t('searchResultsPage.imagesIndexedPercent', '{percent}% indexed', {
      percent,
    }),
  indexedRecords: () => i18n.t('searchResultsPage.indexedRecords', 'View Indexed Records'),
  items: (itemNum, itemTotal) =>
    i18n.t('searchResultsPage.items', '(Item {itemNum} of {itemTotal})', {
      itemNum,
      itemTotal,
    }),
  jiapuCollection: () => i18n.t('searchResultsPage.header.jiapuCollection', 'Jiapu Collection'),
  jiapuOnly: () => i18n.t('searchResultsPage.tab.jiapuOnly', 'Jiapu Only'),
  jokboCollection: () => i18n.t('searchResultsPage.header.jokboCollection', 'Jokbo Collection'),
  jokboOnly: () => i18n.t('searchResultsPage.tab.jokboOnly', 'Jokbo Only'),
  keizuCollection: () => i18n.t('searchResultsPage.header.keizuCollection', 'Keizu Collection'),
  keizuOnly: () => i18n.t('searchResultsPage.tab.KeizuOnly', 'Keizu Only'),
  loading: () => i18n.t('searchResultsPage.loading', 'Loading'),
  needsToBeOrganizedSearch: () => i18n.t('searchResultsPage.needsToBeOrganizedSearch', 'Needs to be Organized'),
  noImagesInGroup: () =>
    i18n.t(
      'searchResultsPage.noImagesInGroup',
      'Images are not available for this group yet. Try checking back later.'
    ),
  noResultsHeading: () => i18n.t('SearchResultsPage.noResultsHeading', 'No Results Found'),
  noResultsMessage: () => i18n.t('SearchResultsPage.noResultsMessage', 'Try adding more information to your search.'),
  noSearchParamsHeader: () => i18n.t('searchResultsPage.noSearchParamsHeader', 'Start by adding a place'),
  noSearchParamsMessage: () =>
    i18n.t(
      'searchResultsPage.noParamsSearchMessage',
      'Get a feel for how many search results you might be dealing with, and then add filters.'
    ),
  openImages: () => i18n.t('searchResultsPage.openImages', 'Open Images'),
  openImagesForGroup: (groupNumber) =>
    i18n.t('searchResultsPage.openImagesForGroup', 'Open Images for image group number {groupNumber}', { groupNumber }),
  organizeGroup: () => i18n.t('searchResultsPage.organizeGroup', 'Organize Group'),
  organizeInProgressHeading: () =>
    i18n.t('searchResultsPage.organizeInProgressMessageHeading', 'Image Organize in progress'),
  organizeInProgressP1: () =>
    i18n.t(
      'searchResultsPage.organizeInProgressP1',
      'Someone is currently working on this image group. You can look for another image group to organize or check back later.'
    ),
  organizeInProgressP2: () =>
    i18n.t(
      'searchResultsPage.organizeInProgressP2',
      'When you close this dialog, the page will reload with the latest data.'
    ),
  refineSearch: () => i18n.t('searchForm.refineSearch', 'Refine Search'),
  reset: () => i18n.t('searchResultsPage.reset', 'Reset'),
  resumeCorrectingMetadata: () => i18n.t('searchResultsPage.resumeCorrectingMetadata', 'Continue Correcting'),
  resumeDividing: () => i18n.t('searchResultsPage.resumeDividing', 'Continue Dividing'),
  someMetadataCorrected: () =>
    i18n.t(
      'searchResultsPage.someMetadataCorrectedCompleteMessage',
      'Correct Metadata task complete for corrected items. All other items are now available for other users to review.'
    ),
  resultsLimited: () =>
    i18n.t(
      'searchResultsPage.warning.resultsLimited',
      'Currently our system cannot go beyond 2,000 search results. We recommend more specific search criteria. If you believe we should increase this limit, please click the Feedback button and send us your thoughts.'
    ),
  unableToDisplayResultsHeading: () =>
    i18n.t('searchResultsPage.unableToDisplayResultsHeading', 'Unable to Display Results'),
  unableToDisplayResultsMessage: () =>
    i18n.t('searchResultsPage.unableToDisplayResultsMessage', 'Try refreshing the page or check back later.'),
  update: () => i18n.t('searchResultsPage.update', 'Update'),
  noResultDialogTitle: (surname) =>
    i18n.t('searchResultsPage.noResultDialogTitle', "Sorry, we don't have {surname} genealogy book.", { surname }),
  noResultDialogBody: () =>
    i18n.t(
      'searchResultsPage.noResultDialogBody',
      'Please try again later, or check our entire collection based on location.'
    ),
  noResultDialogSubtitle: () => i18n.t('searchResultsPage.noResultDialogSubtitle', 'Results (0)'),
  viewResults: () => i18n.t('searchResultsPage.viewResults', 'View Results'),
  withdrawn: () => i18n.t('searchResultsColumns.withdrawn', 'Withdrawn'),
  tableLabel: (place = 'Group Search') =>
    i18n.t('searchResultsPage.tableLabel', 'Table displaying results for {place}', {
      place,
    }),
  sortedBy: (column, dir) =>
    i18n.t('searchResultsPage.sortedBy', 'Table sorted by {column}, {dir}', {
      column,
      dir,
    }),
  ascending: () => i18n.t('searchResultsPage.ascending', 'ascending'),
  descending: () => i18n.t('searchResultsPage.descending', 'descending'),
}
